import { createSlice } from '@reduxjs/toolkit';

import { analyticsReducers } from './reducers';
import { analyticsState } from './state';

export const analyticsSlice = createSlice({
	name: 'Analytics',
	initialState: analyticsState,
	reducers: analyticsReducers,
});

export const { actions, reducer } = analyticsSlice;
